import { Outlet } from "react-router-dom";
import "./App.css";
import Main from "./components/main/Main";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const baseTitle = 'Admin - ApaCanal'; // adjust as needed
    const prefix = process.env.REACT_APP_SERVER_ENV !== 'production' ? 'TEST - ' : '';
    document.title = `${prefix}${baseTitle}`;
  }, []);

  return (
    <>
      {/* <Header /> */}
      <Main>
        <Outlet />
      </Main>
      {/* <Footer /> */}
    </>
  );
}

export default App;
